import React from "react"
import styled from "styled-components/macro"
import { Link } from "gatsby"
import { PageMargin } from "../../GlobalStyles"
import Nav from "../Nav/Nav"
import colors from "../../scripts/colors"
import HeaderContact from "./HeaderContact"

type PropTypes = {
  info: any
  metaData: any
}

const HeaderStyles = styled.header`
  display: flex;
  width: 100%;
  height: 60px;
  background-color: ${colors("grey", "dk")};
  position: relative;
  z-index: 1000;
  border-bottom: 1px solid ${colors("grey")};
  margin-bottom: 70px;
  #Header-contact {
    top: 95px;
  }
  @media screen and (min-width: 1024px) {
    .Site-nav {
      margin-bottom: -5px;
    }
  }
  @media screen and (min-width: 1024px) {
    height: 76px;
    border-bottom-width: 5px;
  }
`

const HeaderPageMargin = styled(PageMargin)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
`

const LogoLink = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
`

const LogoIconImage = styled.img`
  /* position: absolute;
  top: 10px;
  left: -5px; */
  width: 75px;
  height: auto;
  margin-right: 10px;
  margin-top: 7px;
  flex: 0 0 auto;
  @media screen and (min-width: 1024px) {
    width: auto;
    height: 150px;
    /* margin-top: 0; */
  }
`

const LogoTextImage = styled.img`
  align-self: center;
  flex: 0 0 auto;
  margin-top: -15px;
  &#Logo-text--lg {
    display: none;
    height: 35px;
    /* margin-left: 175px; */
    @media screen and (min-width: 1500px) {
      display: block;
      align-self: flex-start;
      margin-top: 20px;
    }
  }
  &#Logo-text--sm {
    display: block;
    @media screen and (min-width: 1024px) {
      align-self: flex-start;
      margin-top: 17px;
    }
    @media screen and (min-width: 1500px) {
      display: none;
    }
  }
`

const Header: React.FC<PropTypes> = ({ info, metaData, currLocation }) => {
  return (
    <HeaderStyles id="Site-header" role="banner">
      <HeaderPageMargin>
        <LogoLink to="/">
          <LogoIconImage
            loading="lazy"
            src={`https://res.cloudinary.com/agoraservices/h_150,q_auto,f_auto/${metaData.logoIconImageId}`}
            alt={`${info.facilityName} logo icon`}
          />
          <LogoTextImage
            loading="lazy"
            id="Logo-text--lg"
            src={`https://res.cloudinary.com/agoraservices/h_35,co_rgb:${colors(
              "grey",
              "xlt",
              1,
              true
            )},e_colorize:100,q_auto,f_auto/${
              metaData.logoTextImageHorizontalId
            }`}
            alt={`${info.facilityName} logo text`}
          />
          <LogoTextImage
            loading="lazy"
            id="Logo-text--sm"
            src={`https://res.cloudinary.com/agoraservices/w_165,q_auto,f_auto,co_rgb:${colors(
              "grey",
              "xlt",
              1,
              true
            )},e_colorize:100/${metaData.logoTextImageId}`}
            alt={`${info.facilityName} logo text`}
          />
        </LogoLink>
        <Nav headerType="default" currLocation={currLocation} />
        <HeaderContact info={info} />
      </HeaderPageMargin>
    </HeaderStyles>
  )
}

export default Header
